import React, { Component } from 'react'
import { Container, Row, Col, Button, Input, InputGroupAddon, InputGroup, InputGroupButton } from 'reactstrap';

export default class Page404 extends Component {
    render() {
        return (
            <div className='app flex-row align-items-center'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md='6'>
                            <div className='clearfix'>
                                <h1 className='float-left display-3 mr-4'>404</h1>
                                <h4 className='pt-3'>Oops! Estás perdido.</h4>
                                <p className='text-muted float-left'>La página que estás buscando no ha sido encontrada.</p>
                            </div>
                            <Row>
                                <Col className=''>
                                    <Button size='lg' color='primary' className='w-100' onClick={() => this.props.history.push('/')} >
                                        <i className='fa fa-home mr-2'></i>Volver al Inicio
                                    </Button>
                                </Col>
                            </Row>
                            {/* <InputGroup className='input-prepend'>
                                <div className='input-group-prepend'>
                                    <span className='input-group-text'>
                                        <i className='fa fa-search'></i>
                                    </span>
                                </div>
                                <Input size='16' type='text' placeholder='What are you looking for?' />
                                <div className='input-group-append'>
                                    <Button color='primary' onClick={() => this.props.history.push('/')} >Volver al Inicio</Button>
                                </div>
                            </InputGroup> */}
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Page404/Page404.js